import { render, staticRenderFns } from "./LoginPageConfiguration.vue?vue&type=template&id=04ae31cb&scoped=true"
import script from "./LoginPageConfiguration.vue?vue&type=script&lang=js"
export * from "./LoginPageConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ae31cb",
  null
  
)

export default component.exports